import React, { PureComponent } from 'react';
import { Product } from '~/Api/Product';
import { Price } from '~/DatasourceComputedPrice';
import { ProductPrice } from '~/Product';
import Icon from '~/UI/Icon/Icon';
import Tooltip from '~/UI/Tooltip';

import Detail from './Detail';
import styles from './styles.less';

interface Props {
	priceType: string | null;
	price: ProductPrice | null;
	product: Product;
	datasourceComputedPrice: Price | null;
	isFetching: boolean;
	styles: { container: string; format: string; icon: string };
	onFetch(): Promise<any>;
}

export default class Info extends PureComponent<Props> {
	static defaultProps = {
		styles,
	};

	componentDidMount() {
		this.props.onFetch();
	}

	renderTooltip() {
		const { priceType, price, product, datasourceComputedPrice, isFetching, styles } = this.props;
		const computedOrigin = price && price.origin?.isComputed ? price.origin?.computed : null;

		if (product.hasAnyPrice() && !computedOrigin) {
			return null;
		}

		const format = computedOrigin ? `${computedOrigin.humanCondensedFormatBasedOnType()}\xa0calc` : null;
		const reference = (
			<span className={styles.format}>
				<span className={styles.icon}>
					<Icon name='exfactory-question-mark' />
				</span>{' '}
				{format}
			</span>
		);

		return (
			<Tooltip reference={reference} width={400}>
				<Detail
					datasourceComputedPrice={datasourceComputedPrice}
					isFetching={isFetching}
					price={price}
					priceType={priceType}
					product={product}
				/>
			</Tooltip>
		);
	}

	render() {
		const { styles } = this.props;

		return <div className={styles.container}>{this.renderTooltip()}</div>;
	}
}
